
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sldwqlurcmytygqlfcco.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNsZHdxbHVyY215dHlncWxmY2NvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUzMzk3OTEsImV4cCI6MjA2MDkxNTc5MX0.VjfZ_Lmq1HIdOyNG5W8yi6IZXff6Lc3SJSDS9dOgLmM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    },
    global: {
      headers: {
        "x-client-info": "lovable",
        "Content-Type": "application/json"
      }
    }
  }
);
